

export class Model_CRM_Opportunity_Shared {
    public OppSharedId: number;
    public OpportunityID: number;
    public UserId: number;
    public IsActive: boolean;


}